import SolutionHeader from 'client/common/components/solution-header/SolutionHeader';

import './SolutionHeader.css';

export default SolutionHeader;
